import { Close } from '@mui/icons-material';
import React, { useEffect, useState } from "react";

import { Row } from "antd";
import Loading from "components/Loading";
import { useTabletDetection } from "containers/chat/hooks";
import { get, has } from "lodash";
import styled from "styled-components";
import COLOR from "utils/constants/color";
import { useShareNotification } from "utils/methods/firebaseShareAssignment";
import ImageUploader from "./imageUploader";

import {
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
} from '@mui/material';

import { makeStyles } from '@mui/styles';
import { useAlert } from "components/UI/alertSakeBar/alertProvider";













const EditSentenceStarter = ({
  editResourseModal,
  onCloseModal,
  item,
  selectedLanguage,
  id
}) => {
  const showAlert = useAlert();
  const [poster, setPoster] = useState(item?.url || "");
  const [englishImageUrl, setEnglishImageUrl] = useState(
    item?.englishImageUrl || ""
  );
  const [loading, setloading] = useState(false);
  const [error, setError] = useState([]);
  const { createSentenceStarter } = useShareNotification();
  const classes = useStyles();
  const [sentenceStarterType, setSentenceStarterType] = useState(
    selectedLanguage || "english"
  );
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const isTablate = useTabletDetection();

  useEffect(() => {
    setSentenceStarterType(selectedLanguage);
  }, [selectedLanguage]);

  useEffect(() => {
    if (item) {
      setPoster(get(item, "url", ""));
      setEnglishImageUrl(get(item, "englishImageUrl", ""));
      setError([]);
    } else {
      setPoster("");
    }

    return () => {
      setPoster("");
      setEnglishImageUrl("");
    };
  }, [item]);

  const onCreateOrUpdate = async () => {
    if (poster?.length === 0 || englishImageUrl?.length === 0) {
      return showAlert("Please Upload English and Spanish Image", "error");
    }
    try {
      if (poster || englishImageUrl) {
        const payload = {
          id: id,
          created_at: new Date(),
          type: sentenceStarterType,
          url: poster || "",
          englishImageUrl: englishImageUrl || "",
        };

        createSentenceStarter(payload,id);
        onCloseModal();
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Modal
      open={editResourseModal}
      onClose={() => {}}
      style={{ height: "100%", width: "100%" }}
    >
      <ModalContent>
        <Row style={{ justifyContent: "space-between" }}>
          <TitleText>
            {has(item, "id")
              ? "Update Sentence Starter"
              : "Add Sentence Starter"}
          </TitleText>
          <IconButton
            onClick={onCloseModal}
            style={{
              padding: 0,
              cursor: "pointer",
              transition: "transform 0.2s ease-in-out",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = "scale(1.1)")
            }
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
          >
            <Close color="secondary" />
          </IconButton>
        </Row>
        <div style={{ marginTop: "20px" }}>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            style={{ transition: "box-shadow 0.3s ease-in-out" }}
          >
            <InputLabel
              style={{ backgroundColor: "white", paddingRight: 5 }}
              id="type"
            >
              Sentence Type
            </InputLabel>
            <Select
              labelId="type"
              id="type"
              value={sentenceStarterType}
              required
              onChange={(v) => {
                setSentenceStarterType(v.target.value);
              }}
              label="Type"
              onFocus={(e) =>
                (e.currentTarget.style.boxShadow = `0 0 8px ${COLOR.green}`)
              }
              onBlur={(e) => (e.currentTarget.style.boxShadow = "none")}
            >
              {MENU?.map((v) => (
                <MenuItem key={v.id} value={v.id}>
                  {v.value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <ModalConfigArea>
          <ImageUploader
            src={sentenceStarterType === "english" ? englishImageUrl : poster}
            path={`/sentence-starter/${sentenceStarterType}`}
            style={{ marginBottom: 24 }}
            onChange={(item) => {
              if (sentenceStarterType === "english") {
                setEnglishImageUrl(item?.url || "");
              } else if (sentenceStarterType === "spanish") {
                setPoster(item?.url || "");
              }
            }}
            hasDescription={false}
          />
        </ModalConfigArea>
        {error.length > 0 ? (
          <Row
            style={{
              marginTop: 10,
              flexDirection: "column",
              display: "flex",
            }}
          >
            {error.map((v) => (
              <FormHelperText key={v.key} error>
                * {get(v, "message")}
              </FormHelperText>
            ))}
          </Row>
        ) : null}

        <AnimatedButton
          disabled={loading || buttonDisabled}
          fullWidth
          onClick={onCreateOrUpdate}
          variant="contained"
          color="primary"
          style={{ marginTop: 20, height: "48px" }}
        >
          {loading ? <Loading white size={15} /> : null}
          {has(item, "id") ? "Update" : "Create"}{" "}
        </AnimatedButton>
      </ModalContent>
    </Modal>
  );
};

export default EditSentenceStarter;

const ModalContent = styled.div`
  overflow: auto;
  left: 50%;
  width: 50vw;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  transition: all 0.3s ease-in-out;
  &:hover {
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.3);
  }
  @media only screen and (max-width: 600px) {
    width: 90%;
  }
`;
const ModalConfigArea = styled.div`
  min-height: 350px;
  max-height: 90vh;
  overflow: auto;
  margin-top: 10px;
  scrollbar-width: thin;
  scrollbar-color: ${COLOR.green} transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${COLOR.green};
    border-radius: 3px;
  }
`;

const TitleText = styled.span`
  font-size: 18px;
  color: black;
  font-weight: 600;
  user-select: none;
`;

const AnimatedButton = styled(Button)`
  transition: all 0.3s ease-in-out !important;
  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
  &:active:not(:disabled) {
    transform: translateY(0);
  }
`;

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: '4px',
  },
  root: {
    marginBottom: "25px",
    width: "300px",
  },
  rootDif: {
    width: "200px",
  },
  rootDifFull: {
    width: "100%",
  },
  sizeSmall: {
    width: "55px",
    height: "25px",
  },
  checkedSwitch: {
    transform: "translateX(30px) !important",
  },
  label: {
    textTransform: "uppercase",
  },
  formControl: {
    minWidth: 120,
  },
  colorPrimary: {
    color: `${COLOR.green}!important`,
  },
  checkroot: {
    display: "flex",
    flexDirection: "column",
  },
  checkformControl: {
    minWidth: 300,
  },
  checksectionTitle: {},
  formGroup: {
    flexDirection: "row", // Arrange checkboxes in a row
    gap: 12,
  },
  checkbox: {
    "&.Mui-checked": {
      color: COLOR.green100, // Custom checked color (green)
    },
  },
}));

const MENU = [
  { id: "english", value: "English Sentence Starter" },
  { id: "spanish", value: "Spanish Sentence starter" },
];